import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";


const ApplePayPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const widgetUrl = searchParams.get("widgetUrl");
  const eventId = searchParams.get("eventId");
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	const isAndroid = /Android/i.test(navigator.userAgent);


  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.status === 'success') {
        navigate(`/events/${eventId}?payment=success`)
      } else if (event.data?.status === 'failed') {
        navigate(`/events/${eventId}?payment=error`)
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md text-center">
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">
          Ödənişi Tamamla
        </h1>
        <p className="text-gray-500 mb-6">
          {isIOS && 'Apple Pay ilə ödəniş etmək üçün aşağıdakı düyməni kliklə.'}
          {isAndroid && 'Google Pay ilə ödəniş etmək üçün aşağıdakı düyməni kliklə.'}
        </p>

        <iframe
          title="apple pay"
          allow="payment"
          src={widgetUrl}
          allowFullScreen
          width="100%"
          height="60"
          className="border-0"
        />

        <p className="text-xs text-gray-400 mt-6">
          Tixy.az tərəfindən qorunur · Təhlükəsiz ödəniş
        </p>
      </div>
    </div>
  );
};

export default ApplePayPage;
